import { render } from "./processFailedModal.vue?vue&type=template&id=1fddda6b"
import script from "./processFailedModal.vue?vue&type=script&lang=js"
export * from "./processFailedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__